module.exports = __webpack_public_path__ + "img/logo-icon.3ed452d9.svg";